(function() {
  'use strict';

  // Initialize marquee sections with dynamic speed scaling
  function initMarquee() {
    const marqueeSection = document.querySelector('[id^="section-"]');
    if (!marqueeSection) return;

    const marqueeTrack = marqueeSection.querySelector('.marquee-track');
    if (!marqueeTrack) return;

    const speedMultiplier = parseFloat(marqueeTrack.dataset.speedMultiplier) || 1.0;
    const baseDuration = 36; // seconds
    const scaledDuration = baseDuration / speedMultiplier;

    // Set CSS variable for animation duration
    marqueeTrack.style.setProperty('--marquee-duration', scaledDuration + 's');

    // Apply inline animation-duration as fallback
    marqueeTrack.style.animationDuration = scaledDuration + 's';
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMarquee);
  } else {
    initMarquee();
  }

  // Also handle Shopify theme customizer updates
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initMarquee);
  }
})();
